import { memo } from "react";

import AlarmDuotoneIcon from "./icons/AlarmDuotone.svg";
import AlarmIcon from "./icons/Alarm.svg";
import AlertsDuotoneIcon from "./icons/AlertsDuotone.svg";
import AndroidLogoIcon from "./icons/AndroidLogo.svg";
import AngularLogoIcon from "./icons/AngularLogo.svg";
import AppleLogoIcon from "./icons/AppleLogo.svg";
import ApplePodcastsLogoIcon from "./icons/ApplePodcastsLogo.svg";
import AppStoreLogoIcon from "./icons/AppStoreLogo.svg";
import ArrowClockwiseIcon from "./icons/ArrowClockwise.svg";
import ArrowCounterClockwiseIcon from "./icons/ArrowCounterClockwise.svg";
import ArrowDownIcon from "./icons/ArrowDown.svg";
import ArrowLeftIcon from "./icons/ArrowLeft.svg";
import ArrowOutIcon from "./icons/ArrowOut.svg";
import ArrowRightIcon from "./icons/ArrowRight.svg";
import ArrowsClockwiseIcon from "./icons/ArrowsClockwise.svg";
import ArrowsDownUpIcon from "./icons/ArrowsDownUp.svg";
import ArrowsLeftRightIcon from "./icons/ArrowsLeftRight.svg";
import ArrowsOutIcon from "./icons/ArrowsOut.svg";
import ArrowsOutSimpleIcon from "./icons/ArrowsOutSimple.svg";
import ArrowSquareLeftDuotoneIcon from "./icons/ArrowSquareLeftDuotone.svg";
import ArrowUpIcon from "./icons/ArrowUp.svg";
import AutometricsColorIcon from "./icons/AutometricsColor.svg";
import AutometricsIcon from "./icons/Autometrics.svg";
import AutometricsLogoBlackFadedIcon from "./icons/AutometricsLogoBlackFaded.svg";
import AutometricsLogoPurpleIcon from "./icons/AutometricsLogoPurple.svg";
import AutometricsLogoTypeIcon from "./icons/AutometricsLogoType.svg";
import BehanceLogoIcon from "./icons/BehanceLogo.svg";
import BellIcon from "./icons/Bell.svg";
import BellNewIcon from "./icons/BellNew.svg";
import BoltDuotoneIcon from "./icons/BoltDuotone.svg";
import BookIcon from "./icons/Book.svg";
import BookOpenIcon from "./icons/BookOpen.svg";
import BracketsAngleIcon from "./icons/BracketsAngle.svg";
import BracketsCurlyIcon from "./icons/BracketsCurly.svg";
import BracketsRoundIcon from "./icons/BracketsRound.svg";
import BracketsSquareIcon from "./icons/BracketsSquare.svg";
import BugBeetleIcon from "./icons/BugBeetle.svg";
import BugDroidIcon from "./icons/BugDroid.svg";
import BugIcon from "./icons/Bug.svg";
import CalendarBlankIcon from "./icons/CalendarBlank.svg";
import CalendarCheckIcon from "./icons/CalendarCheck.svg";
import CalendarPlusIcon from "./icons/CalendarPlus.svg";
import CalendarXIcon from "./icons/CalendarX.svg";
import CallGraphIcon from "./icons/CallGraph.svg";
import CaretDoubleDownIcon from "./icons/CaretDoubleDown.svg";
import CaretDoubleIcon from "./icons/CaretDouble.svg";
import CaretDoubleLeftIcon from "./icons/CaretDoubleLeft.svg";
import CaretDoubleRightIcon from "./icons/CaretDoubleRight.svg";
import CaretDoubleUpIcon from "./icons/CaretDoubleUp.svg";
import CaretDownIcon from "./icons/CaretDown.svg";
import CaretLeftIcon from "./icons/CaretLeft.svg";
import CaretRightIcon from "./icons/CaretRight.svg";
import CaretUpIcon from "./icons/CaretUp.svg";
import ChartBarHorizontalIcon from "./icons/ChartBarHorizontal.svg";
import ChartBarIcon from "./icons/ChartBar.svg";
import ChartLineIcon from "./icons/ChartLine.svg";
import ChartLineUpIcon from "./icons/ChartLineUp.svg";
import ChartPieIcon from "./icons/ChartPie.svg";
import ChartPieSliceIcon from "./icons/ChartPieSlice.svg";
import ChatCircleDotsIcon from "./icons/ChatCircleDots.svg";
import ChatCircleIcon from "./icons/ChatCircle.svg";
import ChatsCircleIcon from "./icons/ChatsCircle.svg";
import CheckboxDuotoneIcon from "./icons/CheckboxDuotone.svg";
import CheckCircleIcon from "./icons/CheckCircle.svg";
import CheckIcon from "./icons/Check.svg";
import CheckSquareIcon from "./icons/CheckSquare.svg";
import ClockClockwiseIcon from "./icons/ClockClockwise.svg";
import ClockCounterClockwiseIcon from "./icons/ClockCounterClockwise.svg";
import ClockIcon from "./icons/Clock.svg";
import CloseIcon from "./icons/X.svg";
import CloudwatchColorIcon from "./icons/CloudwatchColor.svg";
import CloudwatchIcon from "./icons/Cloudwatch.svg";
import CodeDuotoneIcon from "./icons/CodeDuotone.svg";
import CodeIcon from "./icons/Code.svg";
import CodepenLogoIcon from "./icons/CodepenLogo.svg";
import CodesandboxLogoIcon from "./icons/CodesandboxLogo.svg";
import CodeSimpleIcon from "./icons/CodeSimple.svg";
import CombinedIcon from "./icons/Combined.svg";
import CommandIcon from "./icons/Command.svg";
import CopyIcon from "./icons/Copy.svg";
import CpuIcon from "./icons/Cpu.svg";
import DashboardDuotoneIcon from "./icons/DashboardDuotone.svg";
import DatabaseIcon from "./icons/Database.svg";
import DesktopIcon from "./icons/Desktop.svg";
import DeviceMobileIcon from "./icons/DeviceMobile.svg";
import DiscordLogoIcon from "./icons/DiscordLogo.svg";
import DividerIcon from "./icons/Divider.svg";
import DocumentationDuotoneIcon from "./icons/DocumentationDuotone.svg";
import DotsSixVerticalIcon from "./icons/DotsSixVertical.svg";
import DoubleArrowIcon from "./icons/DoubleArrow.svg";
import DownloadIcon from "./icons/Download.svg";
import DribbbleLogoIcon from "./icons/DribbbleLogo.svg";
import DuplicateDuotoneIcon from "./icons/DuplicateDuotone.svg";
import EditDuotoneIcon from "./icons/EditDuotone.svg";
import EditIcon from "./icons/Edit.svg";
import ElasticsearchColorIcon from "./icons/ElasticsearchColor.svg";
import ElasticsearchIcon from "./icons/Elastic.svg";
import EllipsisIcon from "./icons/DotsThree.svg";
import EllipsisVerticalIcon from "./icons/DotsThreeVertical.svg";
import EnvelopeSimpleIcon from "./icons/EnvelopeSimple.svg";
import EnvelopeSimpleOpenIcon from "./icons/EnvelopeSimpleOpen.svg";
import EnvironmentsDuotoneIcon from "./icons/EnvironmentsDuotone.svg";
import ExportDuotoneIcon from "./icons/ExportDuotone.svg";
import ExportIcon from "./icons/Export.svg";
import EyeIcon from "./icons/Eye.svg";
import EyeSlashIcon from "./icons/EyeSlash.svg";
import FacebookLogoIcon from "./icons/FacebookLogo.svg";
import FiberplaneLogoCrackedIcon from "./icons/FiberplaneLogoCracked.svg";
import FiberplaneLogoIcon from "./icons/FiberplaneLogo.svg";
import FiberplaneLogoType from "./icons/FiberplaneLogoType.svg";
import FigmaLogoIcon from "./icons/FigmaLogo.svg";
import FileArrowDownIcon from "./icons/FileArrowDown.svg";
import FileArrowUpIcon from "./icons/FileArrowUp.svg";
import FileCodeIcon from "./icons/FileCode.svg";
import FileCssIcon from "./icons/FileCss.svg";
import FileCsvIcon from "./icons/FileCsv.svg";
import FileDocIcon from "./icons/FileDoc.svg";
import FileDottedIcon from "./icons/FileDotted.svg";
import FileHtmlIcon from "./icons/FileHtml.svg";
import FileIcon from "./icons/File.svg";
import FileImageIcon from "./icons/FileImage.svg";
import FileJpgIcon from "./icons/FileJpg.svg";
import FileJsIcon from "./icons/FileJs.svg";
import FileJsxIcon from "./icons/FileJsx.svg";
import FileLockIcon from "./icons/FileLock.svg";
import FileMinusIcon from "./icons/FileMinus.svg";
import FilePdfIcon from "./icons/FilePdf.svg";
import FilePlusIcon from "./icons/FilePlus.svg";
import FilePngIcon from "./icons/FilePng.svg";
import FilePptIcon from "./icons/FilePpt.svg";
import FileRsIcon from "./icons/FileRs.svg";
import FileSearchIcon from "./icons/FileSearch.svg";
import FilesIcon from "./icons/Files.svg";
import FileTextIcon from "./icons/FileText.svg";
import FileTsIcon from "./icons/FileTs.svg";
import FileTsxIcon from "./icons/FileTsx.svg";
import FileVideoIcon from "./icons/FileVideo.svg";
import FileVueIcon from "./icons/FileVue.svg";
import FileXIcon from "./icons/FileX.svg";
import FileXlsIcon from "./icons/FileXls.svg";
import FileZipIcon from "./icons/FileZip.svg";
import FireIcon from "./icons/Fire.svg";
import FloppyDiskBackIcon from "./icons/FloppyDiskBack.svg";
import FloppyDiskIcon from "./icons/FloppyDisk.svg";
import FolderDottedIcon from "./icons/FolderDotted.svg";
import FolderDuotoneIcon from "./icons/FolderDuotone.svg";
import FolderIcon from "./icons/Folder.svg";
import FolderLockIcon from "./icons/FolderLock.svg";
import FolderOpenDuotoneIcon from "./icons/FolderOpenDuotone.svg";
import FolderOpenIcon from "./icons/FolderOpen.svg";
import FolderPlusIcon from "./icons/FolderPlus.svg";
import FoldersIcon from "./icons/Folders.svg";
import FolderSimpleIcon from "./icons/FolderSimple.svg";
import FramerLogoIcon from "./icons/FramerLogo.svg";
import FunctionDuotoneIcon from "./icons/FunctionDuotone.svg";
import FunctionIcon from "./icons/Function.svg";
import FunnelIcon from "./icons/Funnel.svg";
import FunnelSimpleIcon from "./icons/FunnelSimple.svg";
import GearIcon from "./icons/GearSix.svg";
import GitBranchIcon from "./icons/GitBranch.svg";
import GitCommitIcon from "./icons/GitCommit.svg";
import GitDiffIcon from "./icons/GitDiff.svg";
import GitForkIcon from "./icons/GitFork.svg";
import GithubLogoAltIcon from "./icons/GithubLogoAlt.svg";
import GithubLogoIcon from "./icons/GithubLogo.svg";
import GitlabLogoIcon from "./icons/GitlabLogo.svg";
import GitlabLogoSimpleIcon from "./icons/GitlabLogoSimple.svg";
import GitMergeIcon from "./icons/GitMerge.svg";
import GitPullRequestIcon from "./icons/GitPullRequest.svg";
import GlobeIcon from "./icons/Globe.svg";
import GoogleChromeLogoIcon from "./icons/GoogleChromeLogo.svg";
import GoogleLogoIcon from "./icons/GoogleLogo.svg";
import GooglePhotosLogoIcon from "./icons/GooglePhotosLogo.svg";
import GooglePlayLogoIcon from "./icons/GooglePlayLogo.svg";
import GooglePodcastsLogoIcon from "./icons/GooglePodcastsLogo.svg";
import GraphDuotoneIcon from "./icons/GraphDuotone.svg";
import GraphIcon from "./icons/Graph.svg";
import HighlighterCircleIcon from "./icons/HighlighterCircle.svg";
import ImageIcon from "./icons/Image.svg";
import ImageSquareIcon from "./icons/ImageSquare.svg";
import InfoDuotoneIcon from "./icons/InfoDuotone.svg";
import InfoIcon from "./icons/Info.svg";
import InstagramLogoIcon from "./icons/InstagramLogo.svg";
import KanbanIcon from "./icons/Kanban.svg";
import KeyboardDuotoneIcon from "./icons/KeyboardDuotone.svg";
import KeyIcon from "./icons/Key.svg";
import KeyReturnIcon from "./icons/KeyReturn.svg";
import LightningIcon from "./icons/Lightning.svg";
import LightningSlashIcon from "./icons/LightningSlash.svg";
import LinkBreakIcon from "./icons/LinkBreak.svg";
import LinkedinLogoIcon from "./icons/LinkedinLogo.svg";
import LinkIcon from "./icons/Link.svg";
import LinkOutDuotoneIcon from "./icons/LinkOutDuotone.svg";
import LinkOutIcon from "./icons/LinkOut.svg";
import LinuxLogoIcon from "./icons/LinuxLogo.svg";
import ListBulletsIcon from "./icons/ListBullets.svg";
import ListChecksIcon from "./icons/ListChecks.svg";
import ListDashesIcon from "./icons/ListDashes.svg";
import ListIcon from "./icons/List.svg";
import ListNumbersIcon from "./icons/ListNumbers.svg";
import ListPlusIcon from "./icons/ListPlus.svg";
import LockKeyIcon from "./icons/LockKey.svg";
import LockSimpleIcon from "./icons/LockSimple.svg";
import LockSimpleOpenIcon from "./icons/LockSimpleOpen.svg";
import LokiColorIcon from "./icons/LokiColor.svg";
import LokiIcon from "./icons/Loki.svg";
import MagnetIcon from "./icons/Magnet.svg";
import MagnetStraightIcon from "./icons/MagnetStraight.svg";
import MagnifyingGlassIcon from "./icons/MagnifyingGlass.svg";
import MagnifyingGlassMinusIcon from "./icons/MagnifyingGlassMinus.svg";
import MagnifyingGlassPlusIcon from "./icons/MagnifyingGlassPlus.svg";
import MapPinIcon from "./icons/MapPin.svg";
import ModulesDuotoneIcon from "./icons/ModulesDuotone.svg";
import MoneyDuotoneIcon from "./icons/MoneyDuotone.svg";
import MoonDuotoneIcon from "./icons/MoonDuotone.svg";
import MoonIcon from "./icons/Moon.svg";
import NoteBlankIcon from "./icons/NoteBlank.svg";
import NotebookDuotoneIcon from "./icons/NotebookDuotone.svg";
import NotebookIcon from "./icons/Notebook.svg";
import NotebookMenuIcon from "./icons/NotebookMenu.svg";
import NoteIcon from "./icons/Note.svg";
import NotepadIcon from "./icons/Notepad.svg";
import NotePencilIcon from "./icons/NotePencil.svg";
import NotifcationIcon from "./icons/Notifcation.svg";
import PaperclipIcon from "./icons/Paperclip.svg";
import PaperPlaneTiltIcon from "./icons/PaperPlaneTilt.svg";
import PencilSimpleIcon from "./icons/PencilSimple.svg";
import PercentageIcon from "./icons/Percentage.svg";
import PhoneIcon from "./icons/Phone.svg";
import PieChartDuotoneIcon from "./icons/PieChartDuotone.svg";
import PlugsConnectedIcon from "./icons/PlugsConnected.svg";
import PlugsIcon from "./icons/Plugs.svg";
import PlusBorderedDuotoneIcon from "./icons/PlusBorderedDuotone.svg";
import PlusDuotoneIcon from "./icons/PlusDuotone.svg";
import PlusIcon from "./icons/Plus.svg";
import PresentationIcon from "./icons/Presentation.svg";
import PrinterIcon from "./icons/Printer.svg";
import PrometheusColorGradientDarkIcon from "./icons/PrometheusColorGradientDark.svg";
import PrometheusColorIcon from "./icons/PrometheusColor.svg";
import PrometheusFilledGreyIcon from "./icons/PrometheusFilledGrey.svg";
import PrometheusIcon from "./icons/Prometheus.svg";
import ProxyIcon from "./icons/Proxy.svg";
import PushPinIcon from "./icons/PushPin.svg";
import PushPinSlashIcon from "./icons/PushPinSlash.svg";
import QuestionIcon from "./icons/Question.svg";
import QuotesIcon from "./icons/Quotes.svg";
import RobotIcon from "./icons/Robot.svg";
import RocketIcon from "./icons/Rocket.svg";
import ScissorsIcon from "./icons/Scissors.svg";
import SearchDuotoneIcon from "./icons/SearchDuotone.svg";
import SettingsDuotoneIcon from "./icons/SettingsDuotone.svg";
import ShareNetworkIcon from "./icons/ShareNetwork.svg";
import ShieldCheckIcon from "./icons/ShieldCheck.svg";
import SidebarDotIcon from "./icons/SidebarDot.svg";
import SidebarIcon from "./icons/Sidebar.svg";
import SidebarSimpleIcon from "./icons/SidebarSimple.svg";
import SignOutIcon from "./icons/SignOut.svg";
import SloDuotoneIcon from "./icons/SloDuotone.svg";
import SortAscendingIcon from "./icons/SortAscending.svg";
import SortDescendingIcon from "./icons/SortDescending.svg";
import SourceIcon from "./icons/Source.svg";
import Sparkle from "./icons/Sparkle.svg";
import SquaresFourIcon from "./icons/SquaresFour.svg";
import StackedIcon from "./icons/Stacked.svg";
import StackIcon from "./icons/Stack.svg";
import StarIcon from "./icons/Star.svg";
import SunDuotoneIcon from "./icons/SunDuotone.svg";
import SunIcon from "./icons/Sun.svg";
import TableIcon from "./icons/Table.svg";
import TargetDuotoneIcon from "./icons/TargetDuotone.svg";
import TemplatesIcon from "./icons/Templates.svg";
import TerminalIcon from "./icons/Terminal.svg";
import TerminalWindowIcon from "./icons/TerminalWindow.svg";
import TextAaIcon from "./icons/TextAa.svg";
import TextAlignCenterIcon from "./icons/TextAlignCenter.svg";
import TextAlignJustifyIcon from "./icons/TextAlignJustify.svg";
import TextAlignLeftIcon from "./icons/TextAlignLeft.svg";
import TextAlignRightIcon from "./icons/TextAlignRight.svg";
import TextBolderIcon from "./icons/TextBolder.svg";
import TextboxIcon from "./icons/Textbox.svg";
import TextHFiveIcon from "./icons/TextHFive.svg";
import TextHFourIcon from "./icons/TextHFour.svg";
import TextHIcon from "./icons/TextH.svg";
import TextHOneIcon from "./icons/TextHOne.svg";
import TextHSixIcon from "./icons/TextHSix.svg";
import TextHThreeIcon from "./icons/TextHThree.svg";
import TextHTwoIcon from "./icons/TextHTwo.svg";
import TextIndentIcon from "./icons/TextIndent.svg";
import TextItalicIcon from "./icons/TextItalic.svg";
import TextOutdentIcon from "./icons/TextOutdent.svg";
import TextStrikethroughIcon from "./icons/TextStrikethrough.svg";
import TextTIcon from "./icons/TextT.svg";
import TextUnderlineIcon from "./icons/TextUnderline.svg";
import ThunderIcon from "./icons/Thunder.svg";
import TimeDuotoneIcon from "./icons/TimeDuotone.svg";
import TimerIcon from "./icons/Timer.svg";
import TimeseriesIcon from "./icons/Timeseries.svg";
import TrashIcon from "./icons/Trash.svg";
import TrayIcon from "./icons/Tray.svg";
import TreeStructureIcon from "./icons/TreeStructure.svg";
import TriangleDownIcon from "./icons/Arrow2Down.svg";
import TriangleRightIcon from "./icons/Arrow2Right.svg";
import UploadIcon from "./icons/Upload.svg";
import UserCircleIcon from "./icons/UserCircle.svg";
import UserCircleMinusIcon from "./icons/UserCircleMinus.svg";
import UserCirclePlusIcon from "./icons/UserCirclePlus.svg";
import UsersThreeIcon from "./icons/UsersThree.svg";
import Views from "./icons/Views.svg";
import VSCodeIcon from "./icons/VSCodeLogo.svg";
import WarningCircleIcon from "./icons/WarningCircle.svg";
import WarningIcon from "./icons/Warning.svg";
import WarningOctagonIcon from "./icons/WarningOctagon.svg";
import YoutubeLogoIcon from "./icons/YoutubeLogo.svg";

export const ICON_MAP = {
  alarm_duotone: AlarmDuotoneIcon,
  alarm: AlarmIcon,
  alerts_duotone: AlertsDuotoneIcon,
  android_logo: AndroidLogoIcon,
  angular_logo: AngularLogoIcon,
  app_store_logo: AppStoreLogoIcon,
  apple_logo: AppleLogoIcon,
  apple_podcasts_logo: ApplePodcastsLogoIcon,
  arrow_clockwise: ArrowClockwiseIcon,
  arrow_counter_clockwise: ArrowCounterClockwiseIcon,
  arrow_down: ArrowDownIcon,
  arrow_left: ArrowLeftIcon,
  arrow_out: ArrowOutIcon,
  arrow_right: ArrowRightIcon,
  arrow_square_left_duotone: ArrowSquareLeftDuotoneIcon,
  arrow_up: ArrowUpIcon,
  arrows_clockwise: ArrowsClockwiseIcon,
  arrows_down_up: ArrowsDownUpIcon,
  arrows_left_right: ArrowsLeftRightIcon,
  arrows_out_simple: ArrowsOutSimpleIcon,
  arrows_out: ArrowsOutIcon,
  autometrics_black_faded: AutometricsLogoBlackFadedIcon,
  // The autometrics color logo is very complex so it makes sense to memoize it
  autometrics_color: memo(AutometricsColorIcon),
  autometrics_logo_purple: AutometricsLogoPurpleIcon,
  autometrics_logo_type: AutometricsLogoTypeIcon,
  autometrics: AutometricsIcon,
  behance_logo: BehanceLogoIcon,
  bell_new: BellNewIcon,
  bell: BellIcon,
  bolt_duotone: BoltDuotoneIcon,
  book_open: BookOpenIcon,
  book: BookIcon,
  brackets_angle: BracketsAngleIcon,
  brackets_curly: BracketsCurlyIcon,
  brackets_round: BracketsRoundIcon,
  brackets_square: BracketsSquareIcon,
  bug_beetle: BugBeetleIcon,
  bug_droid: BugDroidIcon,
  bug: BugIcon,
  calendar_blank: CalendarBlankIcon,
  calendar_check: CalendarCheckIcon,
  calendar_plus: CalendarPlusIcon,
  calendar_x: CalendarXIcon,
  call_graph: CallGraphIcon,
  caret_double_down: CaretDoubleDownIcon,
  caret_double_left: CaretDoubleLeftIcon,
  caret_double_right: CaretDoubleRightIcon,
  caret_double_up: CaretDoubleUpIcon,
  caret_double: CaretDoubleIcon,
  caret_down: CaretDownIcon,
  caret_left: CaretLeftIcon,
  caret_right: CaretRightIcon,
  caret_up: CaretUpIcon,
  chart_bar_horizontal: ChartBarHorizontalIcon,
  chart_bar: ChartBarIcon,
  chart_line_up: ChartLineUpIcon,
  chart_line: ChartLineIcon,
  chart_pie_slice: ChartPieSliceIcon,
  chart_pie: ChartPieIcon,
  chat_circle_dots: ChatCircleDotsIcon,
  chat_circle: ChatCircleIcon,
  chats_circle: ChatsCircleIcon,
  check_circle: CheckCircleIcon,
  check_square: CheckSquareIcon,
  check: CheckIcon,
  checkbox_duotone: CheckboxDuotoneIcon,
  clock_clockwise: ClockClockwiseIcon,
  clock_counter_clockwise: ClockCounterClockwiseIcon,
  clock: ClockIcon,
  close: CloseIcon,
  cloudwatch_color: CloudwatchColorIcon,
  cloudwatch: CloudwatchIcon,
  code_duotone: CodeDuotoneIcon,
  code_simple: CodeSimpleIcon,
  code: CodeIcon,
  codepen_logo: CodepenLogoIcon,
  codesandbox_logo: CodesandboxLogoIcon,
  combined: CombinedIcon,
  command: CommandIcon,
  copy: CopyIcon,
  cpu: CpuIcon,
  dashboard_duotone: DashboardDuotoneIcon,
  database: DatabaseIcon,
  desktop: DesktopIcon,
  device_mobile: DeviceMobileIcon,
  discord_logo: DiscordLogoIcon,
  divider: DividerIcon,
  docs_duotone: DocumentationDuotoneIcon,
  dots_six_vertical: DotsSixVerticalIcon,
  dots_three: EllipsisIcon,
  double_arrow: DoubleArrowIcon,
  download: DownloadIcon,
  dribbble_logo: DribbbleLogoIcon,
  duplicate_duo_tone: DuplicateDuotoneIcon,
  edit_duotone: EditDuotoneIcon,
  edit: EditIcon,
  elasticsearch_color: ElasticsearchColorIcon,
  elasticsearch: ElasticsearchIcon,
  ellipsis_vertical: EllipsisVerticalIcon,
  ellipsis: EllipsisIcon,
  envelope_simple_open: EnvelopeSimpleOpenIcon,
  envelope_simple: EnvelopeSimpleIcon,
  environments_duotone: EnvironmentsDuotoneIcon,
  export_duotone: ExportDuotoneIcon,
  export: ExportIcon,
  eye_slash: EyeSlashIcon,
  eye: EyeIcon,
  facebook_logo: FacebookLogoIcon,
  fiberplane_logo_cracked: FiberplaneLogoCrackedIcon,
  fiberplane_logo_type: FiberplaneLogoType,
  fiberplane_logo: FiberplaneLogoIcon,
  figma_logo: FigmaLogoIcon,
  file_arrow_down: FileArrowDownIcon,
  file_arrow_up: FileArrowUpIcon,
  file_code: FileCodeIcon,
  file_css: FileCssIcon,
  file_csv: FileCsvIcon,
  file_doc: FileDocIcon,
  file_dotted: FileDottedIcon,
  file_html: FileHtmlIcon,
  file_image: FileImageIcon,
  file_jpg: FileJpgIcon,
  file_js: FileJsIcon,
  file_jsx: FileJsxIcon,
  file_lock: FileLockIcon,
  file_minus: FileMinusIcon,
  file_pdf: FilePdfIcon,
  file_plus: FilePlusIcon,
  file_png: FilePngIcon,
  file_ppt: FilePptIcon,
  file_rs: FileRsIcon,
  file_search: FileSearchIcon,
  file_text: FileTextIcon,
  file_ts: FileTsIcon,
  file_tsx: FileTsxIcon,
  file_video: FileVideoIcon,
  file_vue: FileVueIcon,
  file_x: FileXIcon,
  file_xls: FileXlsIcon,
  file_zip: FileZipIcon,
  file: FileIcon,
  files: FilesIcon,
  fire: FireIcon,
  floppy_disk_back: FloppyDiskBackIcon,
  floppy_disk: FloppyDiskIcon,
  folder_dotted: FolderDottedIcon,
  folder_duotone: FolderDuotoneIcon,
  folder_lock: FolderLockIcon,
  folder_open_duotone: FolderOpenDuotoneIcon,
  folder_open: FolderOpenIcon,
  folder_plus: FolderPlusIcon,
  folder_simple: FolderSimpleIcon,
  folder: FolderIcon,
  folders: FoldersIcon,
  framer_logo: FramerLogoIcon,
  function_duotone: FunctionDuotoneIcon,
  function: FunctionIcon,
  funnel_simple: FunnelSimpleIcon,
  funnel: FunnelIcon,
  gear: GearIcon,
  git_branch: GitBranchIcon,
  git_commit: GitCommitIcon,
  git_diff: GitDiffIcon,
  git_fork: GitForkIcon,
  git_merge: GitMergeIcon,
  git_pull_request: GitPullRequestIcon,
  github_logo_alt: GithubLogoAltIcon,
  github_logo: GithubLogoIcon,
  gitlab_logo_simple: GitlabLogoSimpleIcon,
  gitlab_logo: GitlabLogoIcon,
  globe: GlobeIcon,
  google_chrome_logo: GoogleChromeLogoIcon,
  google_logo: GoogleLogoIcon,
  google_photos_logo: GooglePhotosLogoIcon,
  google_play_logo: GooglePlayLogoIcon,
  google_podcasts_logo: GooglePodcastsLogoIcon,
  graph_duotone: GraphDuotoneIcon,
  graph: GraphIcon,
  highlighter_circle: HighlighterCircleIcon,
  image_square: ImageSquareIcon,
  image: ImageIcon,
  info_duotone: InfoDuotoneIcon,
  info: InfoIcon,
  instagram_logo: InstagramLogoIcon,
  kanban: KanbanIcon,
  key_return: KeyReturnIcon,
  key: KeyIcon,
  keyboard_duotone: KeyboardDuotoneIcon,
  lightning_slash: LightningSlashIcon,
  lightning: LightningIcon,
  link_break: LinkBreakIcon,
  link_out_duotone: LinkOutDuotoneIcon,
  link_out: LinkOutIcon,
  link: LinkIcon,
  linkedin_logo: LinkedinLogoIcon,
  linux_logo: LinuxLogoIcon,
  list_bullets: ListBulletsIcon,
  list_checks: ListChecksIcon,
  list_dashes: ListDashesIcon,
  list_numbers: ListNumbersIcon,
  list_plus: ListPlusIcon,
  list: ListIcon,
  lock_key: LockKeyIcon,
  lock_simple_open: LockSimpleOpenIcon,
  lock_simple: LockSimpleIcon,
  loki_color: LokiColorIcon,
  loki: LokiIcon,
  magnet_straight: MagnetStraightIcon,
  magnet: MagnetIcon,
  magnifying_glass_minus: MagnifyingGlassMinusIcon,
  magnifying_glass_plus: MagnifyingGlassPlusIcon,
  magnifying_glass: MagnifyingGlassIcon,
  map_pin: MapPinIcon,
  modules_duotone: ModulesDuotoneIcon,
  money_duotone: MoneyDuotoneIcon,
  moon_duotone: MoonDuotoneIcon,
  moon: MoonIcon,
  note_blank: NoteBlankIcon,
  note_pencil: NotePencilIcon,
  note: NoteIcon,
  notebook_duotone: NotebookDuotoneIcon,
  notebook_menu: NotebookMenuIcon,
  notebook: NotebookIcon,
  notepad: NotepadIcon,
  notifcation: NotifcationIcon,
  paper_plane_tilt: PaperPlaneTiltIcon,
  paperclip: PaperclipIcon,
  pencil_simple: PencilSimpleIcon,
  percentage: PercentageIcon,
  phone: PhoneIcon,
  pie_chart_duotone: PieChartDuotoneIcon,
  plugs_connected: PlugsConnectedIcon,
  plugs: PlugsIcon,
  plus_bordered_duotone: PlusBorderedDuotoneIcon,
  plus_duotone: PlusDuotoneIcon,
  plus: PlusIcon,
  presentation: PresentationIcon,
  printer: PrinterIcon,
  prometheus_color_dark: PrometheusColorGradientDarkIcon,
  prometheus_color: PrometheusColorIcon,
  prometheus_filled_grey: PrometheusFilledGreyIcon,
  prometheus: PrometheusIcon,
  proxy: ProxyIcon,
  push_pin_slash: PushPinSlashIcon,
  push_pin: PushPinIcon,
  question: QuestionIcon,
  quotes: QuotesIcon,
  robot: RobotIcon,
  rocket: RocketIcon,
  scissors: ScissorsIcon,
  search_duotone: SearchDuotoneIcon,
  settings_duotone: SettingsDuotoneIcon,
  share_network: ShareNetworkIcon,
  shield_check: ShieldCheckIcon,
  sidebar_dot: SidebarDotIcon,
  sidebar_simple: SidebarSimpleIcon,
  sidebar: SidebarIcon,
  sign_out: SignOutIcon,
  slo_duotone: SloDuotoneIcon,
  sort_ascending: SortAscendingIcon,
  sort_descending: SortDescendingIcon,
  source: SourceIcon,
  sparkle: Sparkle,
  squares_four: SquaresFourIcon,
  stack: StackIcon,
  stacked: StackedIcon,
  star: StarIcon,
  sun_duotone: SunDuotoneIcon,
  sun: SunIcon,
  table: TableIcon,
  target_duotone: TargetDuotoneIcon,
  templates: TemplatesIcon,
  terminal_window: TerminalWindowIcon,
  terminal: TerminalIcon,
  text_aa: TextAaIcon,
  text_align_center: TextAlignCenterIcon,
  text_align_justify: TextAlignJustifyIcon,
  text_align_left: TextAlignLeftIcon,
  text_align_right: TextAlignRightIcon,
  text_bolder: TextBolderIcon,
  text_h_five: TextHFiveIcon,
  text_h_four: TextHFourIcon,
  text_h_one: TextHOneIcon,
  text_h_six: TextHSixIcon,
  text_h_three: TextHThreeIcon,
  text_h_two: TextHTwoIcon,
  text_h: TextHIcon,
  text_indent: TextIndentIcon,
  text_italic: TextItalicIcon,
  text_outdent: TextOutdentIcon,
  text_strikethrough: TextStrikethroughIcon,
  text_t: TextTIcon,
  text_underline: TextUnderlineIcon,
  textbox: TextboxIcon,
  thunder: ThunderIcon,
  time_duotone: TimeDuotoneIcon,
  timer: TimerIcon,
  timeseries: TimeseriesIcon,
  trash: TrashIcon,
  tray: TrayIcon,
  tree_structure: TreeStructureIcon,
  triangle_down: TriangleDownIcon,
  triangle_right: TriangleRightIcon,
  upload: UploadIcon,
  user_circle_minus: UserCircleMinusIcon,
  user_circle_plus: UserCirclePlusIcon,
  user_circle: UserCircleIcon,
  users_three: UsersThreeIcon,
  views: Views,
  vscode: VSCodeIcon,
  warning_circle: WarningCircleIcon,
  warning_octagon: WarningOctagonIcon,
  warning: WarningIcon,
  youtube_logo: YoutubeLogoIcon,
} as const;
